import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';
import type { TrackingProperties } from '@change-corgi/tracking-properties';

import { ScrollTrackingWaypointContainer } from '../../../../../ScrollTrackingWaypoint';
import { AddMediaHit } from '../../../AddMediaHit';
import { MediaHitsScrollButtons } from '../MediaHitsScrollButtons';

type MediaHitsHeaderProps = {
	showAdd: boolean;
	trackingData?: TrackingProperties;
	onScrollLeft: () => void;
	onScrollRight: () => void;
	canScrollLeft: boolean;
	canScrollRight: boolean;
	showScrollButtons: boolean;
};

export function MediaHitsHeader({
	showAdd,
	trackingData,
	onScrollLeft,
	onScrollRight,
	canScrollLeft,
	canScrollRight,
	showScrollButtons,
}: MediaHitsHeaderProps): JSX.Element {
	return (
		<div className="px-6 pt-[52px] md:px-8 md:pt-20" data-testid="media-hits-header-container">
			<div className="flex items-center">
				<Text as="h2" variant="heading" size="large">
					<Translate value="corgi.petition_gamma.media_mentions.title" />
				</Text>
				{showScrollButtons && (
					// Buttons inside already have data-qa attributes
					// eslint-disable-next-line @change-corgi/require-data-qa-attribute
					<MediaHitsScrollButtons
						onScrollLeft={onScrollLeft}
						onScrollRight={onScrollRight}
						canScrollLeft={canScrollLeft}
						canScrollRight={canScrollRight}
					/>
				)}
			</div>
			<ScrollTrackingWaypointContainer name="campaign_media_hits_view" trackingData={trackingData} />
			{showAdd && <AddMediaHit />}
		</div>
	);
}
